// Function to refresh the access token
const refreshAccessToken = async (refreshToken) => {
  const response = await fetch(`https://oauth2.googleapis.com/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams({
      client_id: process.env.REACT_APP_GID,
      client_secret: process.env.REACT_APP_GSECRET,
      refresh_token: refreshToken,
      grant_type: 'refresh_token',
    }),
  });

  const data = await response.json();
  return data.access_token; // New access token
};

// Function to check and refresh token if needed
const getAccessToken = async () => {
  const userData = JSON.parse(localStorage.getItem('user'));
  const currentTime = Date.now() / 1000;

  if (userData.oauthExpireIn <= currentTime) {
    // Token is expired, refresh it
    const newAccessToken = await refreshAccessToken(userData.refreshToken);

    // Update user data with new token and expiry time
    userData.accessToken = newAccessToken;
    userData.oauthExpireIn = currentTime + 3600; // Assuming the new token expires in 1 hour

    localStorage.setItem('user', JSON.stringify(userData));
    return newAccessToken;
  } else {
    // Token is still valid
    return userData.accessToken;
  }
};

export default getAccessToken;